import React from "react";

export default function ShowImages({ pokeName }) {
  pokeName = pokeName.toLowerCase();
  pokeName = pokeName.replaceAll(" ", "-");
  pokeName = pokeName.replaceAll("é", "e");
  let path = process.env.PUBLIC_URL;
  let image = `/images/${pokeName}.png`;
  return <img src={path + image} alt={pokeName} />;
}
